<template>
  <!-- Topbar -->
  <nav
    class="navbar navbar-expand navbar-light bg-white mb-4 static-top shadow"
  >
    <form
      @submit.prevent="filterBy"
      v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
    >
      <div class="row mb-2">
        <div class="col-md-3">
          <div class="form-row">
            <label for="debut" class="col-3">Début:</label>
            <VueCtkDateTimePicker
              name="debut"
              class="ml-0 mr-0 pl-0 pr-0 col-8"
              v-model="start_date"
              label="date début"
              color="#0a3764"
              button-color="#0a3764"
              locale="fr"
              input-size="sm"
              format="YYYY-MM-DD HH:mm:ss"
              button-now-translation="Aujourd'hui"
              id="debut"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-row">
            <label for="fin" class="col-2">Fin:</label>
            <VueCtkDateTimePicker
              name="fin"
              class="ml-0 mr-0 pl-0 pr-0 col-8"
              v-model="end_date"
              label="date fin"
              color="#0a3764"
              button-color="#0a3764"
              locale="fr"
              input-size="sm"
              format="YYYY-MM-DD HH:mm:ss"
              button-now-translation="Aujourd'hui"
              id="fin"
            />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-row">
            <label for="statut" class="col-3">Statut:</label>
            <select id="statut" class="form-control col" v-model="statut">
              <option disabled value="">Sélectionner un statut...</option>
              <option v-for="s in statuts" :value="s.value" :key="s.id">
                {{ s.value }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-row">
            <label for="identifiant" class="col-4">Identifiant:</label>
            <input
              type="text"
              v-model="identifiant"
              name="identifiant"
              id="identifiant"
              class="form-control col"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <label class="col-md-1"></label>
        <div class="col-md-11">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            title="Lancer la recherche"
          >
            Rechercher
          </button>
          <button
            class="btn btn-outline-primary"
            title="Effacer le filtre"
            type="button"
            @click="resetFilter"
          >
            Effacer le filtre
          </button>
        </div>
      </div>
    </form>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

import { FETCH_DEMANDS_FILTER } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { P_READ_DEMAND } from "@/helpers/permissions";

export default {
  name: "Nav",
  components: {},
  data() {
    return {
      start_date: "",
      end_date: "",
      statut: "",
      identifiant: "",
      statuts: [
        { id: 1, value: "GENERATED" },
        { id: 2, value: "PROCESSING" },
        { id: 3, value: "VALIDATION" },
      ],
      P_READ_DEMAND,
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    filterBy() {
      
      this.$store.commit(SET_LOADING, true);

      let params = {};
      if (this.start_date) params.startdate = this.start_date;
      if (this.end_date) params.enddate = this.end_date;
      if (this.identifiant) params.reference = this.identifiant;
      if (this.statut) {
        params.state = this.statut;
      } else {
        params.state = "GENERATED,PROCESSING,VALIDATION";
      }

      // On détruit le dataTable
      this.$emit('destroy:datatable');

      this.$store
        .dispatch(FETCH_DEMANDS_FILTER, params)
        .then(() => {
          // On réaffiche le dataTable
           this.$emit('render:datatable');
        })
        .catch(() => {
          // this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    resetFilter() {
      this.start_date = "";
      this.end_date = "";
      this.statut = "";
      this.identifiant = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.form-row {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
</style>